// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.100.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.100.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wf-toolbar{padding:15px 15px 0}", "",{"version":3,"sources":["webpack://./app/components/wf/affect/list/wf-affect-list.scss"],"names":[],"mappings":"AAAA,YAAY,mBAAmB","sourcesContent":[".wf-toolbar{padding:15px 15px 0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
